import { useSelector } from 'react-redux'

import MarkdownReader from '@/components/MarkdownReader'
import {
  isPrintAssetSelector,
  returnPolicyDaysSelector,
  unusedCodesWithinDaysSelector
} from '@/selectors'
import { translate } from '@/utils/translations'

import WileyCodes from './WileyCodes'

const TRANSLATION_KEY = 'return_policy.modal.rules'

const PurchaseDatePolicy = () => {
  const unusedCodesWithinDays = useSelector(unusedCodesWithinDaysSelector)
  const returnWithinDays = useSelector(returnPolicyDaysSelector)
  const isPrintAsset = useSelector(isPrintAssetSelector)

  return (
    <Choose>
      <When condition={unusedCodesWithinDays}>
        <WileyCodes {...{ returnWithinDays, unusedCodesWithinDays }} />
      </When>
      <Otherwise>
        <li>
          <MarkdownReader>
            {translate(
              `${TRANSLATION_KEY}.return_date_policy`,
              { days: isPrintAsset ? 30 : returnWithinDays }
            )}
          </MarkdownReader>
        </li>
      </Otherwise>
    </Choose>
  )
}

export default PurchaseDatePolicy
